import React, {useEffect, useState} from "react";
import {gql} from "apollo-boost";
import {
    Box,
    Button,
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import useStyles from "../../styles/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import setDate from '../../utils/setDate';
import RenderInput from "../TrafficSource/RenderInput";
import useFormInputs from "../../hooks/useFormInputs";
import _ from "lodash";
import {useQuery} from "@apollo/react-hooks";
import {Alert} from "@material-ui/lab";

const CampaignFilterResultsTableShortForm = ({apiRequestId, apiRequestDateCreated}) => {
    const classes = useStyles();
    const onSubmit = () => {
        const finalInputs = _.omitBy(inputs, _.isEmpty);
        setVariables(finalInputs);
    };
    const {clearAllInputs, inputs, handleFilterChange, handleSubmit} = useFormInputs(onSubmit);
    const [variables, setVariables] = useState();
    const [filteredEntries, setFilterEntries] = useState(false);
    const [showSuccessfulResults, setShowSuccessfulResults] = useState(false)
    const [campaignNames, setCampaignNames] = useState([]);
    const [filterName, setFilterName] = useState([]);
    const handleClick = () => {
        setShowSuccessfulResults(!showSuccessfulResults);
    };

    const handleMouseDown = event => {
        event.preventDefault();
    };

    const {loading, error, data} = useQuery(gql`
        query CampaignFilterResults($apiRequestId: UUID!, $dateCreated: String!) {
            campaignFilterResults(apiRequestId: $apiRequestId, dateCreated: $dateCreated) {
                id
                dateCreated
                filterName
                filterPassed
                reason
                pingTreePass
                campaignData {
                    id
                    name
                }
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
            dateCreated: apiRequestDateCreated
        },
        context: {
            clientName: "kgraphql"
        }
    });

    const getEntries = () => data && data.campaignFilterResults.filter(entry => !entry.result || (showSuccessfulResults && entry.result));

    useEffect(() => {
        if (data && Object.keys(data).length) {
            const filteredEntries = getEntries();
            setFilterEntries(filteredEntries);
            /*
                Set Dropdowns
             */
            const campaignArr = filteredEntries.map(entry => entry.campaign.id);
            const filterNamesArr = filteredEntries.map(entry => entry.filterName);
            setCampaignNames(campaignArr);
            setFilterName(filterNamesArr.length ? [...new Set(filterNamesArr)] : []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        if (variables && Object.keys(variables).length) {
            const {campaignName, filterName} = variables;
            let finalArr = [];
            if (campaignName) {
                finalArr = getEntries().filter(entry => entry.campaign.id === campaignName);
            }
            if (filterName) {
                const filterArr = finalArr.length ? finalArr : getEntries();
                finalArr = filterArr.filter(entry => entry.filterName === filterName);
            }

            setFilterEntries(finalArr);
        } else {
            setFilterEntries(getEntries());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variables])

    if (error) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"campaign-filter-results"}>Campaign
                    Filter Results
                </Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    if (!filteredEntries || loading) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"campaign-filter-results"}>Campaign
                    Filter Results
                </Typography>
                <CircularProgress color="inherit"/>
            </>
        );
    }
    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"campaign-filter-results"}>Campaign
                Filter Results
            </Typography>
            <Paper className={classes.paper}>
                {campaignNames.length && filterName.length ? (
                    <form id="traffic-source-form" onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <RenderInput
                                    item={{
                                        label: 'Campaign Name',
                                        key: 'campaignName',
                                        type: 'autoComplete',
                                        required: false
                                    }}
                                    data={campaignNames}
                                    handleFilterChange={handleFilterChange}
                                    value={inputs['campaignName'] || ''}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <RenderInput
                                    item={{
                                        label: 'Filter Name',
                                        key: 'filterName',
                                        type: 'autoComplete',
                                        required: false
                                    }}
                                    data={filterName}
                                    handleFilterChange={handleFilterChange}
                                    value={inputs['filterName'] || ''}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    fullWidth
                                >
                                    Filter
                                </Button>
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        clearAllInputs();
                                        setVariables({});
                                    }}
                                    fullWidth
                                >
                                    Clear Filters
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                ) : null}
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Created At</TableCell>
                            <TableCell variant="head">Campaign</TableCell>
                            <TableCell variant="head">Filter Name</TableCell>
                            <TableCell variant="head">
                                Result
                                {' '}
                                <IconButton
                                    aria-label={`toggle success visibility`}
                                    onClick={handleClick}
                                    onMouseDown={handleMouseDown}
                                    edge="end"
                                >
                                    {showSuccessfulResults ? <Visibility/> : <VisibilityOff/>}
                                </IconButton></TableCell>
                            <TableCell variant="head">Reason</TableCell>
                            <TableCell variant="head">PingTree Pass</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredEntries.map(entry => (
                            <TableRow key={entry.id}>
                                <TableCell variant="body">{setDate(entry.createdAt)}</TableCell>
                                <TableCell variant="body">
                                    <Box display={"flex"} flexDirection={"column"} style={{padding: '5px 0'}}>
                                        <Box style={{marginBottom: '10px'}}>
                                            <strong>Id:</strong> {entry.campaign.id || 'N/A'}
                                        </Box>
                                        <Box>
                                            <strong>Name:</strong> {entry.campaign.name || 'N/A'}
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell variant="body">{entry.filterName}</TableCell>
                                <TableCell variant="body">{entry.result ? '✅' : '❌'}</TableCell>
                                <TableCell variant="body" style={{whiteSpace: "nowrap"}}>{entry.reason}</TableCell>
                                <TableCell variant="body">{entry.pingTreePass || '—'}</TableCell>
                            </TableRow>
                        ))}
                        {!filteredEntries.length ? (
                            <TableRow>
                                <TableCell variant="body" colSpan={6}>
                                    No Results
                                </TableCell>
                            </TableRow>
                        ) : null}
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
};

export default CampaignFilterResultsTableShortForm
